import type { GlobConfig } from '/#/config';

import {GoingNewUtils, warn} from 'xmgoing-utils';
import { getAppEnvConfig } from '@/utils/env';
import {StorageUtils} from 'xmgoing-utils';
import GoingUtils from "@/utils/goingUtils";

export const useGlobSetting = ({systemName,moreLangFlag}:any): Readonly<GlobConfig> => {
  if(unref(moreLangFlag)){
    StorageUtils.addSessionItem("moreLangFlag",(unref(moreLangFlag)||''));
  }
  if(unref(systemName)){
    StorageUtils.addSessionItem("systemName",(unref(systemName)||''));
  }
  const {
    VITE_GLOB_APP_TITLE,
    VITE_GLOB_API_URL,
    VITE_GLOB_APP_SHORT_NAME,
    VITE_GLOB_API_URL_PREFIX,
    VITE_GLOB_UPLOAD_URL,
  } = getAppEnvConfig();

  if (!/[a-zA-Z\_]*/.test(VITE_GLOB_APP_SHORT_NAME)) {
    warn(
      `VITE_GLOB_APP_SHORT_NAME Variables can only be characters/underscores, please modify in the environment variables and re-running.`,
    );
  }

  // Take global configuration
  const glob: Readonly<GlobConfig> = {
    title: StorageUtils.getSessionItem('systemName')||VITE_GLOB_APP_TITLE,
    apiUrl: VITE_GLOB_API_URL,
    shortName: VITE_GLOB_APP_SHORT_NAME,
    urlPrefix: VITE_GLOB_API_URL_PREFIX,
    uploadUrl: VITE_GLOB_UPLOAD_URL,
    moreLangFlag:GoingNewUtils.parseBoolean(StorageUtils.getSessionItem('moreLangFlag')+'')
  };
  return glob as Readonly<GlobConfig>;
};
